// Modern HRMS Theme Configuration
export const theme = {
  colors: {
    primary: '#19C7D6',      // Teal/Turquoise primary color
    primaryHover: '#10B8D4',  // Darker teal for hover states
    primaryLight: '#E6FAFC',  // Light teal background
    
    secondary: '#0F172A',     // Dark blue-gray
    
    background: {
      main: '#F7F9FC',        // Light gray background
      card: '#FFFFFF',        // White cards
      sidebar: '#FFFFFF',     // White sidebar
      header: '#FFFFFF',      // White header
    },
    
    text: {
      primary: '#0F172A',     // Dark text
      secondary: '#64748B',   // Gray text
      light: '#94a3b8',       // Light gray text
      white: '#FFFFFF',
    },
    
    border: {
      light: '#E7EEF3',       // Light border
      medium: '#CBD5E1',      // Medium border
    },
    
    status: {
      success: '#19C7D6',
      warning: '#F59E0B',
      error: '#EF4444',
      info: '#3B82F6',
    },
    
    chart: {
      purple: '#8B5CF6',
      pink: '#EC4899',
      blue: '#3B82F6',
      green: '#19C7D6',
      orange: '#F59E0B',
      red: '#EF4444',
    }
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  
  borderRadius: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '50%',
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  typography: {
    fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: {
      xs: '11px',
      sm: '13px',
      md: '14px',
      lg: '16px',
      xl: '18px',
      xxl: '24px',
      xxxl: '32px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    }
  }
};

export default theme;

// ─── Flat token object used by AppraisalDetail-style components ───────────────
// Matches the inline `T` object that was previously duplicated in each page.
// Import as:  import { T } from '../styles/theme';
export const T = {
    primary: '#19C7D6',
    primaryDark: '#10B8D4',
    primaryLight: '#E6FAFC',
    primaryLighter: '#F0FEFF',
    orange: '#F59E0B',
    orangeLight: '#FEF3C7',
    blue: '#3B82F6',
    blueLight: '#DBEAFE',
    green: '#10B981',
    greenLight: '#D1FAE5',
    red: '#EF4444',
    redLight: '#FEE2E2',
    purple: '#8B5CF6',
    purpleLight: '#EDE9FE',
    text: '#0F172A',
    textSecondary: '#64748B',
    border: '#E7EEF3',
    bg: '#F7F9FC',
    white: '#FFFFFF',
    shadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
    shadowMd: '0 10px 15px -3px rgba(0,0,0,0.1)',
} as const;

export type ThemeTokens = typeof T;
